/**
 * FT13-U28: Close Cycle Analysis (FSD 2.2.8.10). Spread by INT into the router;
 * no module entitlement, like every close route.
 */

import type { RouteRecordRaw } from 'vue-router'

import { CYCLE_PERMISSIONS } from '@/modules/close/cycle-analysis/api'

export const CLOSE_CYCLE_ANALYSIS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/close/cycle-analysis',
    name: 'close-cycle-analysis',
    component: () => import('@/modules/close/cycle-analysis/CycleAnalysisView.vue'),
    meta: { titleKey: 'close.ft13.routeTitles.cycleAnalysis', permission: CYCLE_PERMISSIONS.read },
  },
]
